import type { DataGetter } from '@rea-argonaut/analytics';
import { trackEvent } from '@rea-argonaut/analytics';
import { deepOmitTypeName } from '../helpers/deepOmitTypeName';

interface EventData<Schema extends string, Data extends Record<string, unknown>> {
  schema: Schema;
  data: Data;
}

export const trackEventAndOmitTypeName = <T extends EventData<string, Record<string, unknown>>>(
  eventData: T,
): void => {
  const event: DataGetter = () => deepOmitTypeName(eventData);
  trackEvent(event);
};
